module.exports = __webpack_public_path__ + "img/upgrade_selector.a6b9a7c6.png";